import './App.css';
import logo from './assets/logo.png';
import qrcode from './assets/qrcode.png';

import {useEffect} from 'react';
import {theme} from './constants';
import {components} from './components';

function App() {
  // useEffect(() => {
  //   const handleResize = () => {
  //     if (window.innerWidth <= 1000) {
  //       window.location.href = 'https://example.com'; // Укажите URL для переадресации
  //     } else {
  //       console.log('Переадресация на google.com');
  //       // window.location.href = 'https://localhost:3000'; // Укажите URL для переадресации
  //     }

  //     // if (window.innerHeight >= 1000) {
  //     //   window.location.href = 'https://google.com'; // Укажите URL для переадресации
  //     // }
  //   };

  //   // Добавление обработчика события при монтировании компонента
  //   window.addEventListener('resize', handleResize);

  //   // Вызов обработчика сразу после монтирования для проверки начального размера окна
  //   handleResize();

  //   // Удаление обработчика события при размонтировании компонента
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'rgba(249, 251, 254, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundImage: 'url("/src/assets/logo.png")',
        // backgroundSize: 'cover',
        // backgroundPosition: 'center',
        // backgroundRepeat: 'no-repeat',
      }}
    >
      <components.Phone />
      <div style={{marginLeft: 70}}>
        {/* Заголовок */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 30,
          }}
        >
          <components.Image src={logo} />
          <components.Image src={qrcode} />
        </div>
        <div
          style={{
            fontSize: 32,
            marginBottom: 14,
            color: theme.colors.mainColor,
            ...theme.fonts.Mulish_700Bold,
          }}
        >
          StepHub - Shoes Store App
        </div>
        {/* Описание */}
        <div
          style={{
            color: theme.colors.textColor,
            marginBottom: 20,
            maxWidth: 500,
            lineHeight: 1.5,
            ...theme.fonts.Mulish_400Regular,
          }}
        >
          StepHub is a cutting-edge Progressive Web Application (PWA) that
          transforms shoe shopping. It combines the convenience of a mobile app
          with the seamless experience of a web application, offering a
          versatile and user-friendly platform for shoe enthusiasts.
        </div>
        {/* Список */}
        <components.Features />
        {/* Описание */}
        <div
          style={{marginBottom: 80, display: 'flex', ...theme.flex.rowCenter}}
        >
          <components.Button
            title='Purchase'
            href='https://themeforest.net/user/george_fx/portfolio'
            containerStyle={{marginRight: 20}}
          />
          <components.Button
            title='Browser version'
            colorScheme='light'
            href='https://stephub-pwa.vercel.app/'
          />
        </div>
        <components.Assistance />
      </div>
    </div>
  );
}

export default App;
